import { ErrorBoundary } from "react-error-boundary";
import { BaseProps } from "src/models/props";

function ErrorFallback({ error, resetErrorBoundary }: any) {
  return (
    <div role="alert">
      <h2>Something went wrong!</h2>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

export function AppErrorBoundary({ children }: BaseProps) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => window.location.reload()} 
      onError={(error, info) => {
        console.error("Caught an error:", error, info);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
